// Single instance of the shared API client for HostApp-twinkle.
// All service forwarders in src/_services/ call through this instance so the auth
// header, basic auth, and 401/403 handling are centralized.
//
// Path strings live in the per-service forwarder files (Phase A constraint — no route
// normalization). The Phase B SDK will absorb the routes once /api/v2 is the contract.

import axios from 'axios';
import { createClient } from '@crewmates/api-client-legacy';
import constant from '../_config/constant';

export const apiClient = createClient({
  axiosInstance: axios,
  baseUrl: constant.apiUrl,
  // onUnauthorized intentionally omitted to match legacy HostApp behavior. The previous
  // axios-based services in this app did NOT auto-logout on 401/403 — the caller handled
  // the error. Preserving that exactly keeps Phase A's "no UI behavior changes" promise.
  // Revisit once the forwarder migration is stable and we can QA the safer behavior.
});
